import createSafeContext from '#/utils/createSafeContext';

import { IChartWidgetApi } from '#/vendor/charting_library/charting_library';

export const [useChart, ChartProvider] =
  createSafeContext<IChartWidgetApi>('Chart');
